export default [
  {
    path: "/search",
    name: "search",
    meta: {
      title: "搜索"
    },
    component: () => import("./search.vue")
  }
];
